export default __webpack_public_path__ + "static/media/work-look.860be83a.jpeg";